<template>
  <v-row justify="center">
    <v-col cols="12" v-if="$store.state.hosted.retrieveLoader">
      <v-skeleton-loader class="mt-5" type="card-heading, list-item-three-line, actions" />
      <v-skeleton-loader class="mt-5" type="card-heading, image, actions" />
    </v-col>
    <template v-else>

      <v-app-bar v-if="isMobileDevice" height="55" :color="form.account.color_background" :dark="isDark" prominent>
        <v-app-bar-nav-icon @click.stop="drawer=!drawer"></v-app-bar-nav-icon>
      </v-app-bar>

      <v-navigation-drawer v-if="isMobileDevice || form.hosted_page_layout === 'vertical'" class="pa-6" v-model="drawer" :dark="isDark" :color="form.account.color_background" width="280px"
        :absolute="isMobileDevice"
        :temporary="isMobileDevice"
        :app="!isMobileDevice"
        :clipped="!isMobileDevice"
        :floating="!isMobileDevice"
        :permanent="!isMobileDevice"
        >
        <v-sheet class="mx-2 mt-2 overflow-hidden" width="90" color="white" rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="90">
              <v-img :src="form.account.logo_url" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-list class="mt-16" dense rounded>
          <v-list-item class="px-2" v-for="mi in form.menu_items" :key="mi.label" :href="mi.url" link>{{mi.label}}</v-list-item>
        </v-list>
        <template v-slot:append>
          <v-list dense rounded>
            <v-list-item class="px-2 body-2" v-if="form.terms_of_service_url" :href="form.terms_of_service_url" link>Términos de uso</v-list-item>
            <v-list-item class="px-2 body-2" v-if="form.privacy_policy_url" :href="form.privacy_policy_url" link>Política de privacidad</v-list-item>
          </v-list>
          <piriod-sign-variant class="px-2" align="center" :dark="isDark" />
        </template>
      </v-navigation-drawer>

      <v-app-bar v-if="!isMobileDevice && form.hosted_page_layout === 'horizontal'" :color="form.account.color_background" :dark="isDark" app elevate-on-scroll>
        <v-sheet class="overflow-hidden mt-14" width="100" rounded outlined>
          <v-responsive class="align-center" :aspect-ratio="1/1">
            <v-sheet class="px-1" color="white" width="100">
              <v-img :src="form.account.logo_url" width="100%" />
            </v-sheet>
          </v-responsive>
        </v-sheet>
        <v-spacer />
        <v-btn class="ml-8" v-for="mi in form.menu_items" :key="mi.label" :href="mi.url" text link>{{mi.label}}</v-btn>
      </v-app-bar>

    </template>
    <v-col cols="12" class="pt-12 pb-0 text-center" v-if="form.account">
      <span class="d-block text-h5 text--secondary font-weight-medium">{{form.hosted_page_title}}</span>
      <span class="d-block my-3">{{form.hosted_page_description}}</span>
    </v-col>
    <v-col cols="12">
      <div id="piriod-widget"></div>
    </v-col>
    <v-col cols="6" class="text-center" v-if="form.account && form.hosted_page_layout === 'horizontal'">
      <v-btn class="ml-4" v-if="form.terms_of_service_url" :href="form.terms_of_service_url" text>Términos de uso</v-btn>
      <v-btn class="ml-4" v-if="form.privacy_policy_url" :href="form.privacy_policy_url" text>Política de privacidad</v-btn>
      <piriod-sign-variant :dark="false" justify="center" />
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import tinycolor from 'tinycolor2'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import PiriodSignVariant from '@/components/PiriodSignVariant'

export default {
  name: 'hosted-signup-forms',
  components: {
    PiriodSignVariant
  },
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    drawer: false
  }),
  computed: {
    ...mapState({
      form: state => cloneDeep(state.hosted.formsDetail)
    }),
    isMobileDevice () {
      return this.$vuetify.breakpoint.width <= 600
    },
    isDark () {
      if (!this.form.account) {
        return false
      }
      const tc = tinycolor(this.form.account.color_background)
      if (tc) {
        return tc.isDark()
      }
      return false
    }
  },
  mounted () {
    window.piriodSettings = {
      service: 'signupForms',
      publishableKey: this.$route.params.publishableKey
    }

    this.installPiriodWidget()
  },
  created () {
    this.$store.dispatch('hosted/RETRIEVE', {
      resource: 'publishable/signup_forms/forms',
      detail: 'hosted',
      id: this.$route.params.publishableKey
    })
    .catch((error) => {
      if (error.response.status === 404) {
        this.$router.push({ name: 'PageExpired' })
      }
    })
  },
  methods: {
    installPiriodWidget () {
      const s = document.createElement('script')

      s.src = this.$JS_BASE + '/embed/piriod-embed.umd.min.js'
      s.async = true
      s.type = 'text/javascript'

      const x = document.getElementsByTagName('script')[0]

      x.parentNode.insertBefore(s, x)
    }
  }
}
</script>
<style>
  .v-toolbar__content {
    margin: 0 auto !important;
    max-width: 860px !important;
  }
</style>